module.exports = __webpack_public_path__ + "img/paw1.5d7d9446.png";